import styled from "@emotion/styled";

export const SelectedItems = styled.div`
  margin-top: 1rem;
`;
